import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetAutopilotPlanDetailV1Response } from './get-autopilot-plan-detail-v1-response';
import { getAutopilotPlanDetailV1ResponseSchema } from './get-autopilot-plan-detail-v1-response';

export async function getAutopilotPlanDetailV1Api(
  planDate: string,
): Promise<IValidatedResponse<IGetAutopilotPlanDetailV1Response>> {
  return getRequest<IGetAutopilotPlanDetailV1Response>({
    path: `/sys/social/v1/autopilot/plans/${planDate}`,
    schema: getAutopilotPlanDetailV1ResponseSchema,
  });
}
